import { render, staticRenderFns } from "./SkeletonCourseVideo.vue?vue&type=template&id=0516126d&scoped=true"
import script from "./SkeletonCourseVideo.vue?vue&type=script&lang=js"
export * from "./SkeletonCourseVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516126d",
  null
  
)

export default component.exports